import React, { Component } from "react";
import { Button, FileUploader } from "devextreme-react";
import Api from "Api/Api";
import Copy from "components/common/Copy";

export default class Attachments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      links: [],
      loading: false,
    };

    this.togglePopup = () => {
      this.setState({
        visible: !this.state.visible,
      });
    };
    this.toggleLoading = () => {
      this.setState({
        loading: !this.state.loading,
      });
    };
    this.uploading = (e) => {
      this.toggleLoading();
      Api.mailAttachments(e.value).then((response) => {
        this.toggleLoading();
        if (response.status === 200) {
          this.setState({ links: response.data });
        }
      });
    };
  }

  render() {
    return (
      <>
        <Button
          text="Attachments"
          onClick={this.togglePopup}
          useSubmitBehavior={false}
        />
        {this.state.visible ? (
          <>
            <FileUploader
              uploadMode="useForm"
              multiple={true}
              onValueChanged={this.uploading}
              readyToUploadMessage=""
            />
            {this.state.loading && <p>Please Wait...</p>}
            <div className="links">
              {this.state.links.map((link) => {
                return <Copy content={link} toBeCopied={link} />;
              })}
            </div>
          </>
        ) : null}
      </>
    );
  }
}
